import { createAction } from '@reduxjs/toolkit';
export const REMOVE_INCOMING_CALL = 'REMOVE_INCOMING_CALL';
export const removeIncomingCallAction = createAction(REMOVE_INCOMING_CALL);